<template>
  <router-link
    class="avatar-box"
    :class="{ editable: employer.id != 0 }"
    :to="'/' + token + '/members#' + employer.id"
  >
    <editBox
      :option="['edit', 'remove']"
      :item="'employer'"
      :itemId="employer.id"
      displayMode="horizontal_bottom"
      v-if="employer.id != 0"
    />
    <div class="avatar-img-div">
      <img
        :src="
          employer.id == 0
            ? getImgUrl(employer.employee_img)
            : 'https://witrino.com/' + employer.employee_img
        "
        alt=""
      />
    </div>
    <p class="user-name">
      {{ employer.user_name }}
    </p>
    <p class="user-side">
      {{ employer.grade }}
    </p>
  </router-link>
</template>

<script>
import { sellerData } from "@/repo/sellerData.js";
import { publicHelpers } from "@/public/helpers";
import editBox from "@/components/editBox/index.vue";
export default {
  name: "AvatarCircleBOX",
  components: {
    editBox,
  },
  mixins: [sellerData, publicHelpers],
  props: ["employer", "token"],
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/AvatarCircleBOX/AvatarCircleBOX.css);
</style>